module.exports = __webpack_public_path__ + "img/main-image.ae0e6086.jpg";